// Shared static style constants — imported by connection-log-app.jsx components.
// Theme-dependent styles live in theme.js (via SA/GLASS/STATUS_STYLES).

/** Base for all modal overlay backdrops. Spread this and add zIndex + layout props. */
export const overlayBackdrop = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.28)",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
};

/** Standard centered-modal overlay (desktop). Add zIndex per usage. */
export const overlayCentered = {
  ...overlayBackdrop,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 24,
};

/** Common button row for form footers. */
export const formButtonRow = { display: "flex", gap: 8 };
